
import React, { useEffect, useState } from 'react';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import './chart.css'
import ChartCard from './ChartCard';
import ChartList from './ChartList';
import img from  "../../assets/images/robo.png"
const OurChart = () => {

    const [chartDoc, setChartDoc] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.ourChart,
            })
            .then((response) => {
                const chartInfo = response.data.allOur_charters.edges[0].node;
                setChartDoc(chartInfo);


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <section style={{ backgroundImage: 'url(' + chartDoc?.section_bg?.url + ')' }} className="pattern chart-container">
            <div className="container">
            <h3 className="subtitle ">{chartDoc?.title}</h3>
                <div  className="row g-4">
                    <div className="col-md-5 first-card px-0  d-flex flex-column justify-content-between ">
                    <div className="charter-img">
                     <img src={chartDoc?.charter_info[0]?.img?.url} className="img-fluid w-100" alt="" />
                    </div>
                        <div className=" ps-3 pe-2 pb-2">
                   < ChartCard info ={chartDoc?.charter_info[0]} firstCard={true}  />
                   </div>
                    </div>
                    <div  className="col-md-7 ">
                        <div className="row g-4">
                            {chartDoc?.charter_info.slice(1,3).map((info,index) => <ChartCard key={index +1} info={info} />)}
                        </div>
                    </div>
                </div>

            </div>

        </section>
    );
};

export default OurChart;


// import React, { useEffect, useState } from 'react';
// import client from '../../utils/prismicHelpers';
// import * as queries from "../../utils/prismicQueries";
// import './chart.css'
// import ChartList from './ChartList';
// const OurChart = () => {

//     const [chartDoc, setChartDoc] = useState(null);


//     useEffect(() => {
//         client
//             .query({
//                 query: queries.ourChart,
//             })
//             .then((response) => {
//                 const chartInfo = response.data.allOur_charters.edges[0].node;
//                 setChartDoc(chartInfo);


//             })
//             .catch((error) => {
//                 console.error(error);
//             });
//     });
//     return (
//         <section style={{ backgroundImage: 'url(' + chartDoc?.section_bg?.url + ')' }} className="pattern chart-container">
//             <div className="container">
           
//                 <div  >
//                     <h3 className="subtitle ">{chartDoc?.title}</h3>
//                     <p className="body-text pt-2">{chartDoc?.description}</p>
//                 </div>
//                 <div>
//                     {
//                         chartDoc?.charter_info?.map((chartInfo ,index)=> <ChartList key={index+1}  chartInfo={chartInfo} />)
//                     }

//                 </div>
//             </div>

//         </section>
//     );
// };

// export default OurChart;